/**
 * Created by Ning Jiang on 2023-08-29.
 */

import {DCRoadSymbol} from "./DCRoadSymbol";
import {gsap, TimelineLite} from "gsap";
import {DevilsCrossRoad} from "../DevilsCrossRoad";
import {DCRoadReelsController} from "../reels/DCRoadReelsController";

export class ScatterSymbol extends DCRoadSymbol {

    public isSuper:boolean;

    constructor(reelId:number, symId:number) {
        super("S", reelId, symId);
    }

    protected initSpine():void {
        if(!this._spine) {
            this._spine = new PIXI.spine.Spine(DevilsCrossRoad.assetLoader.getSpineAsset(this.symbolName[0]));
            this._spine.autoUpdate = true;
            // this._animationContainer.addChild(this._spine);
        }
    }

    public playLanding(init:boolean):TimelineLite {
        DevilsCrossRoad.scatters.addScatter(this, init);
        // TODO: play scatter animation based on DevilsCrossRoad.scatters.counter;
        const tl = super.playLanding(init);
        tl.add(() => {
            this._spine.state.setAnimation(0, "idle", true);
        });
        if(this.reelId > 0 && this.reelId < 4 && this.symId > 0 && this.symId < 4) {
            tl.add(this.playAvalanche());
        }
        return tl;
    }

    public playAvalanche():TimelineLite {
        this.isSuper = true;
        DevilsCrossRoad.scatters.avalancheScatter(DCRoadReelsController.DEV_WAYS_MAP[this.reelId][this.symId]);
        const tl = gsap.timeline();
        tl.add(() => {
            this._spine.state.setAnimation(0, "ver2_transition", false);
        });
        tl.add(() => {
            this._spine.state.setAnimation(0, "ver2_idle", true);
        }, `+=${this._spine.spineData.findAnimation("ver2_transition").duration}`);
        return tl;
    }

    public playWinFS():TimelineLite {
        const aniName = this.isSuper ? "ver2_FS_transition" : "FS_transition";
        const tl = gsap.timeline();
        tl.add(() => {
            this._spine.state.setAnimation(0, aniName, false);
        });
        tl.add(() => {
        }, `+=${this._spine.spineData.findAnimation(aniName).duration}`);
        tl.add(() => {}, `+=0.5`);
        return tl;
        // return gsap.timeline()
        //     .to(this._animationContainer.scale, {duration : 0.3, x : 1.2, y : 1.2})
        //     .to(this._animationContainer.scale, {duration : 0.2, x : 1, y : 1})
        //     .to(this._animationContainer.scale, {duration : 0.3, x : 1.2, y : 1.2})
        //     .to(this._animationContainer.scale, {duration : 0.2, x : 1, y : 1});
    }
}